const timelineTypes = {
  ACTIVATING: 1,
  LINEUP: 2,
  COCREATING: 3,
  COMPLETE: 4,
  EMPTY: 0
}

const timelineTypeLists = [
  {
    title: 'Activating',
    value: timelineTypes.ACTIVATING
  },
  {
    title: 'Pairing',
    value: timelineTypes.LINEUP
  },
  {
    title: 'Co-Creating',
    value: timelineTypes.COCREATING
  },
  {
    title: 'Complete',
    value: timelineTypes.COMPLETE
  }
  // {
  //   title: '-',
  //   value: timelineTypes.EMPTY
  // }
]

const tableHeaders = [
  {
    text: 'Date (DD/MM/YYYY)',
    value: 'timelineDate'
  },
  {
    text: 'Action',
    value: 'action'
  },
  {
    text: 'Action by',
    value: 'actionBy'
  },
  {
    text: '',
    value: 'controlAction'
  }
]

const summaryTableHeaders = [
  {
    text: 'Campaign Name',
    value: 'name',
    align: 'center'
  },
  {
    text: 'AM',
    value: 'AM',
    align: 'center'
  },
  {
    text: 'CC',
    value: 'CC',
    align: 'center'
  },
  {
    text: 'Activating',
    value: 'activating',
    align: 'center'
  },
  {
    text: 'Pairing',
    value: 'pairing',
    align: 'center'
  },
  {
    text: 'Cocreating',
    value: 'cocreating',
    align: 'center'
  },
  {
    text: 'Complete',
    value: 'complete',
    align: 'center'
  },
  {
    text: 'Total Duration',
    value: 'totalDuration',
    align: 'center'
  },
  {
    text: 'Actions',
    value: 'actions',
    align: 'center'
  }
]

const defaultTableItems = [
  {
    timelineDate: '',
    startDate: '',
    endDate: '',
    actionType: timelineTypeLists[0],
    actionTitle: 'Activating',
    actionDesc: '-',
    actionBy: 'Kobe'
  },
  {
    timelineDate: '',
    startDate: '',
    endDate: '',
    actionType: timelineTypeLists[1],
    actionTitle: 'Pairing',
    actionDesc: `-`,
    actionBy: 'Kobe, Client, Creator'
  },
  {
    timelineDate: '',
    startDate: '',
    endDate: '',
    actionType: timelineTypeLists[2],
    actionTitle: 'Co-Creating',
    actionDesc: `-`,
    actionBy: 'Kobe, Client, Creator'
  },
  {
    timelineDate: '',
    startDate: '',
    endDate: '',
    actionType: timelineTypeLists[3],
    actionTitle: 'Complete',
    actionDesc: `-`,
    actionBy: 'Kobe'
  }
]

const defaultSummaries = {
  activating: {
    title: 'Activating',
    projected: 'invalid',
    actual: 'invalid',
    actualTasks: [
      {
        title: 'Brief created',
        type: 'a',
        value: 'invalid'
      },
      {
        title: 'Brief accepted',
        type: 'b',
        value: 'invalid'
      }
    ]
  },
  pairing: {
    title: 'Pairing',
    projected: 'invalid',
    actual: 'invalid',
    actualTasks: [
      // {
      //   title: 'Shortlisting Days',
      //   type: 'a',
      //   value: 'invalid'
      // },
      {
        title: 'Brief Accepted',
        type: 'a',
        value: 'invalid'
      },
      // {
      //   title: 'Shortlisting End Date',
      //   type: 'c',
      //   value: 'invalid'
      // },
      // {
      //   title: 'Confirming Days',
      //   type: 'd',
      //   value: 'invalid'
      // },
      {
        title: 'First payout confirmed',
        type: 'b',
        value: 'invalid'
      },
      {
        title: 'All payouts confirmed',
        type: 'c',
        value: 'invalid'
      }
    ]
  },
  cocreating: {
    title: 'Co-creating',
    projected: 'invalid',
    actual: 'invalid',
    actualTasks: [
      // {
      //   title: 'Executing Days',
      //   type: 'a',
      //   value: 'invalid'
      // },
      {
        title: 'All payouts confirmed',
        type: 'a',
        value: 'invalid'
      },
      // {
      //   title: 'Executing End Date',
      //   type: 'c',
      //   value: 'invalid'
      // },
      // {
      //   title: 'Submitting Days',
      //   type: 'd',
      //   value: 'invalid'
      // },
      {
        title: 'First Submitted on IMS',
        type: 'b',
        value: 'invalid'
      },
      // {
      //   title: 'Submitting End Date',
      //   type: 'f',
      //   value: 'invalid'
      // },
      // {
      //   title: 'Live Days',
      //   type: 'g',
      //   value: 'invalid'
      // },
      {
        title: 'Earliest liveDate in Report',
        type: 'c',
        value: 'invalid'
      },
      {
        title: 'Latest liveDate in Report',
        type: 'd',
        value: 'invalid'
      }
    ]
  },
  complete: {
    title: 'Complete',
    projected: '',
    actual: 'invalid',
    actualTasks: [
      // {
      //   title: 'Finishing Days',
      //   type: 'a',
      //   value: 'invalid'
      // },
      {
        title: 'Latest liveDate',
        type: 'a',
        value: 'invalid'
      },
      {
        title: 'Review Meeting',
        type: 'b',
        value: 'invalid'
      }
    ]
  }
}
export default {
  tableHeaders,
  summaryTableHeaders,
  defaultTableItems,
  timelineTypes,
  timelineTypeLists,
  defaultSummaries
}



// WEBPACK FOOTER //
// ./src/components/views/Campaign/Timeline/config.js